import React from "react"
import { useHistory } from "react-router-dom"
import constants from "utils/constants"
import arrowiconright from "images/arrowiconright.png"
import arrowIcon from "images/arrow_icon.png"
import {
	Generatemain,
	GenerateTop,
	User,
	Userimg,
	Username,
	Textbox,
	Arrowright,
	Setlistinner,
	Setlist,
	Setlistname,
	Setlistcont,
	Setlistdata,
	TopInner,
	Title,
	Back,
	Finish,
	UserImgTag,
} from "./style"

export default function RoutineCreateForm({
	userInfo,
	selectResult,
	setTodoalarm,
	setTodotext,
	updateNext,
	rutineDay,
	rutineWeek,
	dataSubmit,
	todotext,
}) {
	const todotextChange = (e) => {
		setTodotext(e.target.value)
	}
	const history = useHistory()
	return (
		<Generatemain>
			<TopInner style={{ borderBottom: "solid calc(100vw*(1/375)) #d5d5d5" }}>
				<Back
					onClick={() => {
						history.goBack()
					}}
				>
					<img src={arrowIcon} alt={"back button"} />
				</Back>
				<Title>루틴 추가</Title>
				<Finish onClick={dataSubmit}> 완료 </Finish>
			</TopInner>

			<GenerateTop>
				<User>
					<Userimg>
						<UserImgTag
							src={`${constants.imagePath}/user_profile_img/${userInfo.profile_img}`}
							alt={"current user profile"}
						/>
					</Userimg>
					<Username>{userInfo["name"]}</Username>
				</User>
				<Textbox
					type="text"
					placeholder="나만의 루틴을 추가해 보세요 :)"
					value={todotext}
					onChange={todotextChange}
				/>
			</GenerateTop>

			<Setlistinner
				onClick={() => {
					updateNext(1)
				}}
			>
				<SetList
					listname={"루틴 시작날짜/요일"}
					listdata={rutineDay}
					listdataWeek={rutineWeek ? " / " + selectResult : null}
				/>
			</Setlistinner>
		</Generatemain>
	)
}

function SetList({ listname, listdata, click, listdataWeek }) {
	return (
		<Setlist onClick={click}>
			<Setlistname>{listname}</Setlistname>
			<Setlistcont>
				<Setlistdata>
					{listdata}
					{listdataWeek}
				</Setlistdata>
				<Arrowright>
					<img src={arrowiconright} alt={"detail info setting"} />
				</Arrowright>
			</Setlistcont>
		</Setlist>
	)
}
